import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  getApiKeys,
  createApiKey,
  deleteApiKey,
  ApiKey,
  CreateOrgApiKeyRequest,
  DeleteApiKeyRequest,
} from '@/services/ApiKeys/org-api-key.service';

export const orgApiKeysApiSlice = createApi({
  reducerPath: 'orgApiKeysApi',
  tagTypes: ['OrgApiKeys'],
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    getApiKeys: builder.query<ApiKey[], { organizationId: string; search?: string }>({
      queryFn: async ({ organizationId, search }) => {
        try {
          const data = await getApiKeys(organizationId, search);
          return { data };
        } catch (error) {
          return { error: { status: 'FETCH_ERROR', error: String(error) } };
        }
      },
      providesTags: ['OrgApiKeys'],
    }),
    createApiKey: builder.mutation<string, CreateOrgApiKeyRequest>({
      queryFn: async (request: CreateOrgApiKeyRequest) => {
        try {
          const data = await createApiKey(request);
          return { data };
        } catch (error) {
          return { error: { status: 'FETCH_ERROR', error: String(error) } };
        }
      },
      invalidatesTags: ['OrgApiKeys'],
    }),
    deleteApiKey: builder.mutation<{ success: boolean }, DeleteApiKeyRequest>({
      queryFn: async (request: DeleteApiKeyRequest) => {
        try {
          const data = await deleteApiKey(request);
          return { data };
        } catch (error) {
          return { error: { status: 'FETCH_ERROR', error: String(error) } };
        }
      },
      invalidatesTags: ['OrgApiKeys'],
    }),
  }),
});

export const {
  useGetApiKeysQuery,
  useLazyGetApiKeysQuery,
  useCreateApiKeyMutation,
  useDeleteApiKeyMutation,
} = orgApiKeysApiSlice;
